import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import AuditIncidentListView from "src/components/pages/audit/auditIncidentListView/auditIncidentListView";
import AuditInputUpload from "src/components/pages/audit/auditInputUpload/auditInputUpload";
import AuditReviewView from "src/components/pages/audit/auditReview/auditReviewView";
import AuditDashboard from "src/components/pages/audit/auditDashboard/auditDashboard";
import AutomatedJobReview from "src/components/pages/automatedJobs/automatedJobReview";
import AutomatedJobs from "src/components/pages/automatedJobs/automatedJobs";
import AutomatedJobManagement from "src/components/pages/automatedJobs/automatedJobManagement";
import BatchProcess from "src/components/pages/batchProcess/batchProcess";
import DataExtraction from "src/components/pages/dataExtraction/dataExtraction";
import ModelManagement from "src/components/pages/modelManagement/modelManagement";
import ValidationWorkflow from "src/components/pages/validationWorkflow/groundTruthFileUploadView/validationWorkflow";
import ModelGroundTruthListView from "src/components/pages/validationWorkflow/groundTruthListView/modelGroundTruthListView";
import ModelGroundTruthReview from "src/components/pages/validationWorkflow/groundTruthReview/modelGroundTruthReview";
import {
  CPT_AUDITOR_LDAP_GROUP,
  CPT_AUDITOR_ADMIN_LDAP_GROUP,
  DUMMY_MODEL_ID,
  ADMIN_LDAP_GROUP,
  ENGINEER_LDAP_GROUP,
} from "src/constants";
import { getModelById, resetField } from "src/store/modelManagementSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import BatchRecordListView from "src/components/pages/batchProcess/batchReordListView/batchReordListView";
import BatchRecordReview from "src/components/pages/batchProcess/batchRecordReview/batchRecordReview";

const MainContent = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { selectedModelId } = useAppSelector((state) => state.modelSlice);

  const { ldap, userLoading } = useAppSelector((state) => state.user);

  useEffect(() => {
    if (selectedModelId !== "" && selectedModelId !== DUMMY_MODEL_ID) {
      dispatch(getModelById(selectedModelId));
      dispatch(resetField());
    }
  }, [selectedModelId, location.pathname]);

  return (
    <Routes>
      <Route path="/" element={<DataExtraction />} />
      <Route path="/dataExtraction" element={<DataExtraction />} />
      <Route path="/modelManagement" element={<ModelManagement />} />
      <Route path="/batchProcess" element={<BatchProcess />} />
      <Route path="/batchProcess/:batchJobId" element={<BatchRecordListView />} />
      <Route path="/batchProcess/:batchJobId/:sourceId" element={<BatchRecordReview />} />

      {ldap.includes(CPT_AUDITOR_LDAP_GROUP) && (
        <Route path="/audit" element={<AuditInputUpload />} />
      )}
      {ldap.includes(CPT_AUDITOR_LDAP_GROUP) && (
        <Route path="/audit/:auditWorkflowId" element={<AuditIncidentListView />} />
      )}
      {ldap.includes(CPT_AUDITOR_LDAP_GROUP) && (
        <Route path="/audit/:auditWorkflowId/:incidentId" element={<AuditReviewView />} />
      )}
      {(ldap.includes(ADMIN_LDAP_GROUP) ||
        ldap.includes(ENGINEER_LDAP_GROUP) ||
        ldap.includes(CPT_AUDITOR_ADMIN_LDAP_GROUP)) && (
        <Route path="/auditAnalyzer" element={<AuditDashboard />} />
      )}
      <Route path="/validationWorkflow" element={<ValidationWorkflow />} />
      <Route path="/validationWorkflow/:modelId" element={<ModelGroundTruthListView />} />
      <Route path="/validationWorkflow/:modelId/:sourceId" element={<ModelGroundTruthReview />} />

      <Route path="/automatedJobs" element={<AutomatedJobs />} />
      {ldap.includes(ENGINEER_LDAP_GROUP) && (
        <Route path="/automatedJobs/manage" element={<AutomatedJobManagement />} />
      )}
      <Route path="/automatedJobs/:jobId" element={<AutomatedJobs />} />
      <Route path="/automatedJobs/:jobId/:sourceId" element={<AutomatedJobReview />} />

      {userLoading === "fulfilled" && <Route path="*" element={<Navigate to="/" replace />} />}
    </Routes>
  );
};

export default MainContent;
